import { useEffect, useState } from "react";

let deferred = null;
const subs = new Set();
const tell = () => subs.forEach((f) => f());
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; tell(); });
window.addEventListener("appinstalled", () => { deferred = null; tell(); });

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isPhone = () => window.matchMedia?.("(max-width: 767px)").matches || window.matchMedia?.("(pointer: coarse)").matches;

export const useInstall = () => {
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick((x) => x + 1); subs.add(f); return () => subs.delete(f); }, []);
  const prompt = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const r = await deferred.userChoice;
    deferred = null; tell();
    return r.outcome === "accepted";
  };
  return { canPrompt: !!deferred, installed: standalone(), ios: isIos(), prompt };
};
